import { DateFieldsDefinition, SubDateFieldDefinition } from '../util/moment.utils';
import { Moment } from 'moment';

export interface IAdherentInformations {
  numero?: string;
  prenom?:string;
  nom?: string;
  telephonePortable1?: string;
  email?: string;
  statut?: string;
  fonction?: string;
  dateDeNaissance?: Moment;
  adherentFormations?: IAdherentFormation[];
  adherentDiplomes?: IAdherentDiplome[];
  adherentQualifications?: IAdherentQualification[];
}

export class AdherentInformations implements IAdherentInformations {
  constructor(
    public numero?: string,
    public prenom?:string,
    public nom?: string,
    public telephonePortable1?: string,
    public email?: string,
    public statut?: string,
    public  fonction?: string,
    public dateDeNaissance?: Moment,
    public adherentFormations?: IAdherentFormation[],
    public adherentDiplomes?: IAdherentDiplome[],
    public adherentQualifications?: IAdherentQualification[]
  ) { }
}

export interface IAdherentFormation {
  libelle?: string;
  type?: string;
  dateFin?: Moment;
  role?: string;
}

export class AdherentFormation implements IAdherentFormation {
  constructor(
    public libelle?: string,
    public type?: string,
    public dateFin?: Moment,
    public role?: string
  ) { }
}

export interface IAdherentDiplome {
  type?: string;
  dateObtention?: Moment;
}

export class AdherentDiplome implements IAdherentDiplome {
  constructor(
    public type?: string,
    public dateObtention?: Moment
  ) { }
}

export interface IAdherentQualification {
  estTitulaire?: boolean;
  type?: string;
  dateFin?: Moment
}

export class AdherentQualification implements IAdherentQualification {
  constructor(
    public estTitulaire?: boolean,
    public type?: string,
    public dateFin?: Moment,
  ) {
  }
}

const ADHERENT_FORMATION_DATE_FIELDS_DEFINITION = new DateFieldsDefinition(['dateFin']);
const ADHERENT_DIPLOME_DATE_FIELDS_DEFINITION = new DateFieldsDefinition(['dateObtention']);
const ADHERENT_QUALIFICATION_DATE_FIELDS_DEFINITION = new DateFieldsDefinition(['dateFin']);

export const ADHERENT_INFORMATIONS_DATE_FIELDS_DEFINITION = new DateFieldsDefinition( ['dateDeNaissance'], {
  adherentFormations: new SubDateFieldDefinition(ADHERENT_FORMATION_DATE_FIELDS_DEFINITION, true),
  adherentDiplomes: new SubDateFieldDefinition(ADHERENT_DIPLOME_DATE_FIELDS_DEFINITION, true),
  adherentQualifications: new SubDateFieldDefinition(ADHERENT_QUALIFICATION_DATE_FIELDS_DEFINITION, true),
});
